import api from '../index'

export interface CopybookItem {
  id: string
  template_id: number
  name: string
  content: string
  options?: Record<string, any> | null
  created_at: string
  updated_at: string
  template?: {
    id: number
    name: string
  }
}

export interface CopybookListParams {
  page?: number
  limit?: number
  search?: {
    name?: string
  }
}

export interface CopybookFormData {
  id?: string
  template_id: number
  name: string
  content: string
  options?: Record<string, any> | null
}

export default {
  getCopybookList: (params: CopybookListParams = {}): Promise<{ data: { list: CopybookItem[], total: number, limit: number } }> => {
    return api.get('/Copybook/getCopybookList', { params })
  },

  createCopybook: (data: CopybookFormData): Promise<{ data: CopybookItem }> => {
    return api.post('/Copybook/createCopybook', data)
  },

  getCopybookDetail: (id: string): Promise<{ data: CopybookItem }> => {
    return api.get('/Copybook/getCopybookDetail', { params: { id } })
  },

  updateCopybook: (data: CopybookFormData): Promise<{ data: CopybookItem }> => {
    return api.post('/Copybook/updateCopybook', data)
  },

  deleteCopybook: (id: string): Promise<{ data: any }> => {
    return api.post('/Copybook/deleteCopybook', { id })
  },
}
